class RmCartUpsell {
  constructor() {
    const config = this.getConfig();

    if (!config || config.enabled !== true) {
      return;
    }

    this.config = {
      upsellVariantId: Number(config.upsellVariantId),
      disqualifyingProductIds: new Set(config.disqualifyingProductIds.map(Number)),
      disqualifyingVariantIds: new Set(config.disqualifyingVariantIds.map(Number)),
    };
    this.cartForm = document.getElementById('cart');
    this.modal = document.getElementById('RmCartUpsellModal');
    this.acceptButton = this.modal?.querySelector('[data-rm-cart-upsell-accept]');
    this.declineButton = this.modal?.querySelector('[data-rm-cart-upsell-decline]');
    this.feedbackElement = this.modal?.querySelector('[data-rm-cart-upsell-feedback]');
    this.isSubmitting = false;
    this.acceptButtonLabel = this.acceptButton?.querySelector('span');
    this.defaultAcceptButtonText = this.acceptButtonLabel?.textContent || 'Add 1oz Bottle';

    if (!this.cartForm) {
      return;
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDecline = this.handleDecline.bind(this);
    this.handleAccept = this.handleAccept.bind(this);

    this.cartForm.addEventListener('submit', this.handleSubmit);
    this.declineButton?.addEventListener('click', this.handleDecline);
    this.acceptButton?.addEventListener('click', this.handleAccept);
  }

  handleSubmit(event) {
    const submitter = event.submitter || document.activeElement;

    if (!submitter || submitter.name !== 'checkout') {
      return;
    }

    event.preventDefault();

    const eligibility = this.evaluateCartEligibility();
    console.info('RM Cart Upsell Debug', eligibility);

    if (eligibility.isEligible) {
      this.showModal(submitter);
      return;
    }

    this.continueToCheckout();
  }

  evaluateCartEligibility() {
    const cartState = this.getCartState();

    if (!cartState) {
      return {
        isEligible: false,
        reason: 'missing-cart-state',
      };
    }

    for (const item of cartState.items) {
      const productId = Number(item.productId);
      const variantId = Number(item.variantId);

      if (this.config.disqualifyingProductIds.has(productId)) {
        return {
          isEligible: false,
          reason: 'matched-disqualifying-product',
          matchedProductId: productId,
        };
      }

      if (this.config.disqualifyingVariantIds.has(variantId)) {
        return {
          isEligible: false,
          reason: 'matched-disqualifying-variant',
          matchedVariantId: variantId,
        };
      }

      if (variantId === this.config.upsellVariantId) {
        return {
          isEligible: false,
          reason: 'upsell-already-in-cart',
          matchedVariantId: variantId,
        };
      }
    }

    return {
      isEligible: true,
      reason: 'no-disqualifying-items-found',
    };
  }

  getCartState() {
    const stateElement = document.getElementById('rm-cart-upsell-state');

    if (!stateElement) {
      return null;
    }

    try {
      return JSON.parse(stateElement.textContent);
    } catch (error) {
      console.error('RM Cart Upsell Debug: failed to parse cart state.', error);
      return null;
    }
  }

  getConfig() {
    const configElement = document.getElementById('rm-cart-upsell-config');

    if (!configElement) {
      return null;
    }

    try {
      return JSON.parse(configElement.textContent);
    } catch (error) {
      console.error('RM Cart Upsell Debug: failed to parse upsell config.', error);
      return null;
    }
  }

  showModal(submitter) {
    if (!this.modal) {
      this.continueToCheckout(submitter);
      return;
    }

    this.clearFeedback();
    this.setSubmittingState(false);
    this.modal.show(submitter);
  }

  handleDecline() {
    if (this.isSubmitting) {
      return;
    }

    if (this.modal) {
      this.modal.hide();
    }

    this.continueToCheckout();
  }

  handleAccept() {
    if (this.isSubmitting) {
      return;
    }

    this.clearFeedback();
    this.setSubmittingState(true);

    this.addUpsellToCart()
      .then(() => {
        if (this.modal) {
          this.modal.hide();
        }

        this.continueToCheckout();
      })
      .catch((error) => {
        console.error('RM Cart Upsell Debug: failed to add upsell item.', error);
        this.showFeedback('We could not add the 1oz bottle right now. Please try again.');
      })
      .finally(() => {
        this.setSubmittingState(false);
      });
  }

  addUpsellToCart() {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', this.config.upsellVariantId);
    formData.append('quantity', '1');
    config.body = formData;

    return fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          throw new Error(response.description || response.message || 'Unable to add upsell item.');
        }

        return response;
      });
  }

  setSubmittingState(isSubmitting) {
    this.isSubmitting = isSubmitting;

    if (this.acceptButton) {
      this.acceptButton.disabled = isSubmitting;
      this.acceptButton.setAttribute('aria-disabled', isSubmitting ? 'true' : 'false');
    }

    if (this.declineButton) {
      this.declineButton.disabled = isSubmitting;
      this.declineButton.setAttribute('aria-disabled', isSubmitting ? 'true' : 'false');
    }

    if (this.acceptButtonLabel) {
      this.acceptButtonLabel.textContent = isSubmitting ? 'Adding...' : this.defaultAcceptButtonText;
    }
  }

  showFeedback(message) {
    if (!this.feedbackElement) {
      return;
    }

    this.feedbackElement.textContent = message;
    this.feedbackElement.hidden = false;
  }

  clearFeedback() {
    if (!this.feedbackElement) {
      return;
    }

    this.feedbackElement.textContent = '';
    this.feedbackElement.hidden = true;
  }

  getCheckoutUrl() {
    if (window.shopUrl) {
      return `${window.shopUrl}/checkout`;
    }

    return '/checkout';
  }

  continueToCheckout() {
    window.location.assign(this.getCheckoutUrl());
  }
}

new RmCartUpsell();